import type { User } from 'firebase/auth';
import { ADMIN_EMAILS } from '@/data/admins';

/**
 * Client-side admin check. Mirrors the rules-side check exactly:
 * - User is signed in
 * - Email is in the allowlist
 * - Email is verified (Google sign-in auto-verifies; password auth
 *   requires the user to click the verification link)
 *
 * This is UI-only — Firestore + Storage rules enforce the real
 * permission, so even if a client bypassed this check, writes would
 * still be rejected server-side.
 */
export function isAdmin(user: User | null | undefined): boolean {
  if (!user || !user.email) return false;
  if (!user.emailVerified) return false;
  return ADMIN_EMAILS.includes(user.email.toLowerCase());
}

/**
 * Like isAdmin() but ignores email_verified — used to tell a would-be
 * admin "you need to verify your email" instead of just hiding admin
 * entry points entirely.
 */
export function isAdminEmail(user: User | null | undefined): boolean {
  if (!user || !user.email) return false;
  return ADMIN_EMAILS.includes(user.email.toLowerCase());
}
